import { FORM_FIELDS } from '../../../../../../../../constants';

export const PARAMS_STEP_FIELDS = [
    FORM_FIELDS.MONTHLY_SALARY,
    FORM_FIELDS.REGION,
    FORM_FIELDS.REGION_LOCATION_ROUTE,
    FORM_FIELDS.FIRST_NAME,
    FORM_FIELDS.LAST_NAME,
    FORM_FIELDS.MIDDLE_NAME,
    FORM_FIELDS.FULL_NAME,
    FORM_FIELDS.EMAIL,
    FORM_FIELDS.PHONE,
];

export const PARAMS_STEP_AUTH_VALIDATION_FIELDS = [
    FORM_FIELDS.MONTHLY_SALARY,
    FORM_FIELDS.REGION,
    FORM_FIELDS.REGION_LOCATION_ROUTE,
    FORM_FIELDS.FIRST_NAME,
    FORM_FIELDS.LAST_NAME,
    FORM_FIELDS.MIDDLE_NAME,
    FORM_FIELDS.FULL_NAME,
];
